<div class="body-main" *ngIf="this.accesslevelNumber=='0'"> 
  <div class="body-main-top"> 

	<section class="container-fluid mt-2 mt-md-3 mb-4">  
		<div class="row">              
			<div class="box col-12"> 
				<div class="box-header">
					<div class="box-title">
						<div class="row align-items-center">
							<div class="col"><h3>AccessLevel</h3></div>
							<div class="col-auto">
								 
							</div>
							<div class="col-auto"><button type="button" class="btn btn-secondary" (click)="backtoSection('accesslevel')" >Back to Home</button></div>
						</div>    
					</div> 
				</div> 
				<div class="box-body">
					<div class="row">
						<div class="col-md-12"> 							
							<form (ngSubmit)="onSubmit(aclForm)" #aclForm="ngForm" novalidate>
								<!-- <div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
										{{ rtnData.message }}
								</div> -->
								<div class="form-group"> <label for="UserRole">User Type</label>
									<select class="form-control" id="UserRole" [(ngModel)]= "UserRole"
										required name="UserRole" #UserRoleM="ngModel" (change)="getAccessDetails(this.UserRole)">
										<option value="">Select User Type</option>
										<option *ngFor="let usertype of userTypes" [value]="usertype.id">{{usertype.userType}}</option>
									</select>
									<div *ngIf="rtnData && rtnData.message.roleID" class="alert alert-danger">
										{{rtnData.message.roleID}}
									</div> 
								</div>
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover">
										<thead>
										<tr>
											<th>Pages</th>
											<th>View</th>
											<th>Add</th>
											<th>Edit</th>
											<th>Delete</th>
										</tr>
										</thead>
										<tbody>
											<tr>
												<td>User</td>
												<td> 
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_user_control" [(ngModel)]= "view_user_control" #view_user_controlM="ngModel" [ngModelOptions]="{standalone: true}" id="user1">
														<label class="custom-control-label" for="user1"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_user_control" [(ngModel)]= "add_user_control" #add_user_controlM="ngModel" id="user2"> 
														<label class="custom-control-label" for="user2"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_user_control" [(ngModel)]= "edit_user_control" #edit_user_controlM="ngModel" id="user3">
														<label class="custom-control-label" for="user3"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_user_control" [(ngModel)]= "delete_user_control" #delete_user_controlM="ngModel" id="user4">
														<label class="custom-control-label" for="user4"></label>
													</div>
												</td>
											</tr>
											<tr>
												<td>Access Level</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input"  name="view_accesslevel_control" [(ngModel)]= "view_accesslevel_control" #view_accesslevel_controlM="ngModel" [ngModelOptions]="{standalone: true}" id="access1">
														<label class="custom-control-label" for="access1"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_accesslevel_control" [(ngModel)]= "add_accesslevel_control" #add_accesslevel_controlM="ngModel"  id="access2"> 
														<label class="custom-control-label" for="access2"></label>
													</div>
												</td> 
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_accesslevel_control" [(ngModel)]= "edit_accesslevel_control" #edit_accesslevel_controlM="ngModel" id="access3">
														<label class="custom-control-label" for="access3"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_accesslevel_control" [(ngModel)]= "delete_accesslevel_control" #delete_accesslevel_controlM="ngModel" id="access4">
														<label class="custom-control-label" for="access4"></label>
													</div>
												</td>
											</tr>
											<!-- <tr>
												<td>Role</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_role_control" [(ngModel)]= "view_role_control" #view_role_controlM="ngModel" [ngModelOptions]="{standalone: true}" id="role1">
														<label class="custom-control-label" for="role1"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_role_control" [(ngModel)]= "add_role_control" #add_role_controlM="ngModel" id="role2">
														<label class="custom-control-label" for="role2"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_role_control" [(ngModel)]= "edit_role_control" #edit_role_controlM="ngModel" id="role3">
														<label class="custom-control-label" for="role3"></label>	
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_role_control" [(ngModel)]= "delete_role_control" #delete_role_controlM="ngModel" id="role4">
														<label class="custom-control-label" for="role4"></label>
													</div>
												</td>
											</tr> -->
											<tr>
												<td>Account</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_acc_control" [(ngModel)]= "view_acc_control" #view_acc_controlM="ngModel" [ngModelOptions]="{standalone: true}" id="account1">
														<label class="custom-control-label" for="account1"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_acc_control" [(ngModel)]= "add_acc_control" #add_acc_controlM="ngModel" id="account2">
														<label class="custom-control-label" for="account2"></label>
													</div>													 
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_acc_control" [(ngModel)]= "edit_acc_control" #edit_acc_controlM="ngModel" id="account3">
														<label class="custom-control-label" for="account3"></label>
													</div>													
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_acc_control" [(ngModel)]= "delete_acc_control" #delete_acc_controlM="ngModel" id="account4">
														<label class="custom-control-label" for="account4"></label>
													</div>													
												</td>
											</tr>
											<tr>
												<td>Project</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_project_control" [(ngModel)]= "view_project_control" #view_project_controlM="ngModel" id="project1">
														<label class="custom-control-label" for="project1"></label>
													</div>													
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_project_control" [(ngModel)]= "add_project_control" #add_project_controlM="ngModel" id="project2">
														<label class="custom-control-label" for="project2"></label>
													</div>													
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_project_control" [(ngModel)]= "edit_project_control" #edit_project_controlM="ngModel" id="project3">
														<label class="custom-control-label" for="project3"></label>
													</div>													
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_project_control" [(ngModel)]= "delete_project_control" #delete_project_controlM="ngModel" id="project4">
														<label class="custom-control-label" for="project4"></label>
													</div>													
												</td>
											</tr> 
											<tr>
												<td>RuleEngine Access</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_createrule_control" [(ngModel)]= "view_createrule_control" #view_createrule_controlM="ngModel" id="rule1">
														<label class="custom-control-label" for="rule1"></label>
													</div> 
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_createrule_control" [(ngModel)]= "add_createrule_control" #add_createrule_controlM="ngModel" id="rule2">
														<label class="custom-control-label" for="rule2"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_createrule_control" [(ngModel)]= "edit_createrule_control" #edit_createrule_controlM="ngModel" id="rule3">
														<label class="custom-control-label" for="rule3"></label>
													</div> 
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_createrule_control" [(ngModel)]= "delete_createrule_control" #delete_createrule_controlM="ngModel" id="rule4">
														<label class="custom-control-label" for="rule4"></label>
													</div>													
												</td>
											</tr>	
											<tr>
												<td>Create Application</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="view_createapp_control" [(ngModel)]= "view_createapp_control" #view_createapp_controlM="ngModel" id="create-app1">
														<label class="custom-control-label" for="create-app1"></label>
													</div> 
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="add_createapp_control" [(ngModel)]= "add_createapp_control" #add_createapp_controlM="ngModel"  id="create-app2">
														<label class="custom-control-label" for="create-app2"></label>
													</div>
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="edit_createapp_control" [(ngModel)]= "edit_createapp_control" #edit_createapp_controlM="ngModel" id="create-app3">
														<label class="custom-control-label" for="create-app3"></label>
													</div>													
												</td>
												<td>
													<div class="custom-control custom-checkbox">
														<input type="checkbox" class="custom-control-input" name="delete_createapp_control" [(ngModel)]= "delete_createapp_control" #delete_createrule_controlM="ngModel" id="create-app4">
														<label class="custom-control-label" for="create-app4"></label>		
													</div>													
												</td>
											</tr>
										</tbody>
									</table> 
								</div>
								<div class="text-right">
								<button type="submit" class="btn btn-primary">SUBMIT</button>
								</div>
			 				 </form>
						</div>  
					</div>
				</div>
			</div>
		</div>
	</section>  
   </div>
</div>